import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogujratcabservice() {



  const cardData =
  {
    keyword: 'Pune to Gujarat Cab Service',
    heading: 'Sanavi Travels: Pune to Gujarat Cab Service',
    headingDescription: 'Sanavi Travels offers reliable Pune to Gujarat Cab Service, providing safe, comfortable, and hassle-free transportation for families, corporate travelers, tourists, and groups traveling from Pune to various destinations in Gujarat. Our fleet of sedans, SUVs, and luxury cabs is well-maintained with spacious seating, air-conditioning, and ample luggage space, ensuring a smooth and relaxing long-distance journey. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, reliable, and stress-free travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular Gujarat destinations such as Ahmedabad, Vadodara, Surat, Rajkot, Gir National Park, Somnath, Dwarka, and Saputara. Choose Sanavi Travels for trusted Pune to Gujarat cab services, delivering comfort, safety, and a seamless long-distance travel experience.',

    top: 'Top Places to Visit in Gujrat with Sanavi Travels',


"topPlaces": [
  {
    "title": "Somnath Temple",
    "description": "Somnath Temple is one of the twelve Jyotirlinga shrines dedicated to Lord Shiva, located on the Arabian Sea coast. Known for its stunning architecture and spiritual significance, the temple attracts pilgrims and tourists alike. The evening light and sound show adds to the temple’s grandeur."
  },
  {
    "title": "Gir National Park",
    "description": "Gir National Park is India’s only natural habitat of the Asiatic lion. Spread across dense forests and grasslands, it offers wildlife safaris and nature trails. Visitors can spot lions, leopards, antelopes, and a variety of birds, making it a must-visit for wildlife enthusiasts."
  },
  {
    "title": "Rani ki Vav",
    "description": "Rani ki Vav in Patan is a UNESCO World Heritage Site, famous for its intricately carved stepwell architecture. Built in the 11th century, it features sculptural panels depicting gods, goddesses, and mythological scenes. It is a fine example of Gujarat’s historic craftsmanship."
  },
  {
    "title": "Dwarka",
    "description": "Dwarka is a sacred city on the western coast of Gujarat, associated with Lord Krishna. The Dwarkadhish Temple, dedicated to Krishna, is a major pilgrimage site, attracting devotees from across India. The city also offers scenic views of the Arabian Sea."
  },
  {
    "title": "Saputara",
    "description": "Saputara is Gujarat’s only hill station, located in the Sahyadri ranges. Known for its serene lakes, lush gardens, and viewpoints, it is ideal for trekking, boating, and relaxing amidst nature. Saputara also hosts cultural festivals and tribal markets."
  },
  {
    "title": "Ahmedabad – Sabarmati Ashram",
    "description": "Sabarmati Ashram in Ahmedabad is a historic site associated with Mahatma Gandhi. It preserves his personal belongings, photographs, and letters, offering insight into India’s freedom struggle. The ashram overlooks the Sabarmati River and serves as a center for peace and history."
  },
  {
    "title": "Sun Temple, Modhera",
    "description": "Sun Temple in Modhera is an architectural marvel built in the 11th century, dedicated to Surya, the Sun God. The temple features intricate carvings, a stepped tank, and a spacious assembly hall, showcasing Gujarat’s rich temple architecture."
  },
  {
    "title": "Lothal",
    "description": "Lothal is an important archaeological site from the Indus Valley Civilization, known for its dockyard, bead-making workshops, and ancient artifacts. It provides insights into ancient urban planning, trade, and craftsmanship in Gujarat."
  },
  {
    "title": "Kutch – Rann of Kutch",
    "description": "The Rann of Kutch is a vast salt marsh in Gujarat, famous for the white desert and the Rann Utsav festival. Visitors can enjoy camel rides, cultural performances, handicrafts, and panoramic sunset and sunrise views. The region is a unique blend of natural beauty and local culture."
  },
  {
    "title": "Bhuj – Aina Mahal",
    "description": "Aina Mahal in Bhuj is a historic palace known for its European-influenced architecture and intricate interiors. The palace houses royal artifacts, mirrors, and paintings, reflecting the rich cultural and artistic heritage of Kutch and Gujarat."
  }
]
,




"services": [
  {
    "name": "Pune to Gujarat Cab Service",
    "description": "Pune to Gujarat Cab Service provides a reliable, comfortable, and safe travel solution for individuals, families, and corporate travelers. Fully air-conditioned cabs with spacious seating and ample luggage space ensure a smooth long-distance journey. Professional chauffeurs handle route planning, traffic, and timely pickups, making one-way or round trips stress-free. Ideal for weekend getaways, corporate travel, or family vacations, this service focuses on comfort, convenience, and affordability for an enjoyable Pune to Gujarat trip."
  },
  {
    "name": "Gujarat Cab from Pune",
    "description": "Gujarat Cab from Pune offers a dependable option for travelers commuting between Pune and Gujarat. Fully air-conditioned vehicles with professional chauffeurs provide a safe, comfortable, and timely journey. Suitable for families, corporate groups, solo travelers, or friends, this service ensures flexibility in pickup and drop-off locations and stress-free long-distance travel."
  },
  {
    "name": "AC Cab Pune to Gujarat",
    "description": "AC Cab Pune to Gujarat guarantees a cool and comfortable long-distance travel experience. Air-conditioned cabs with ample legroom, luggage space, and smooth ride quality ensure a pleasant journey even in hot weather. Experienced chauffeurs manage routes efficiently and provide timely pickups. Perfect for families, tourists, corporate groups, and long-distance travelers seeking convenience and comfort."
  },
  {
    "name": "Luxury Cab Gujarat Trip",
    "description": "Luxury Cab Gujarat Trip provides a premium travel experience for comfort-conscious travelers. Fully air-conditioned luxury vehicles with modern amenities and spacious seating make the journey relaxing and stylish. Professional chauffeurs ensure safe navigation, timely pickups, and smooth travel. Suitable for couples, corporate groups, or families seeking a high-end Pune to Gujarat travel experience."
  },
  {
    "name": "Family Cab Gujarat",
    "description": "Family Cab Gujarat is designed for families traveling from Pune to Gujarat. Spacious cabs with air-conditioning, luggage space, and comfortable seating make long journeys enjoyable. Experienced drivers ensure safety and punctuality, making this service ideal for weekend trips, vacations, or family excursions. Convenience, reliability, and comfort are prioritized for every family member."
  },
  {
    "name": "Outstation Cab Gujarat",
    "description": "Outstation Cab Gujarat offers a dependable solution for travelers seeking long-distance transportation between Pune and Gujarat. Fully air-conditioned vehicles with professional chauffeurs ensure smooth, safe, and stress-free travel. Perfect for solo travelers, groups, or corporate travelers planning one-way or round trips, this service provides comfort, convenience, and flexibility for outstation journeys."
  },
  {
    "name": "Affordable Cab Gujarat",
    "description": "Affordable Cab Gujarat provides budget-friendly travel options without compromising on comfort or safety. Fully air-conditioned vehicles with professional drivers make the long-distance journey from Pune to Gujarat comfortable and reliable. Ideal for students, families, and groups, this service offers economical yet convenient and stress-free travel."
  },
  {
    "name": "Chauffeur Driven Cab Gujarat",
    "description": "Chauffeur Driven Cab Gujarat ensures a professional and relaxing travel experience. Experienced drivers handle navigation, traffic, and route planning while passengers enjoy air-conditioned, spacious vehicles. Perfect for families, groups, corporate travelers, or solo passengers seeking a safe, punctual, and comfortable journey between Pune and Gujarat."
  },
  {
    "name": "Best Cab Pune to Gujarat",
    "description": "Best Cab Pune to Gujarat offers a premium long-distance travel experience. Fully air-conditioned, well-maintained vehicles with experienced chauffeurs guarantee safety, comfort, and punctuality. Ideal for families, corporate travelers, groups, or solo tourists, this service ensures a smooth, enjoyable, and reliable Pune to Gujarat journey."
  },
  {
    "name": "Pune Gujarat Taxi",
    "description": "Pune Gujarat Taxi is a dependable travel solution for long-distance trips. Spacious, air-conditioned vehicles with professional chauffeurs provide comfort, safety, and reliability. Flexible pickup and drop-off options make this service suitable for families, corporate groups, or friends traveling from Pune to Gujarat."
  },
  {
    "name": "Tourist Cab Gujarat",
    "description": "Tourist Cab Gujarat is designed for travelers planning sightseeing or leisure trips from Pune to Gujarat. Fully air-conditioned cabs with spacious interiors and professional drivers provide a smooth and safe journey. This service is ideal for families, groups, or solo tourists seeking a comfortable and hassle-free long-distance travel experience."
  },
  {
    "name": "Long Distance Cab Pune",
    "description": "Long Distance Cab Pune specializes in providing safe, comfortable, and reliable travel for routes like Pune to Gujarat. Fully air-conditioned vehicles with professional chauffeurs ensure a stress-free journey. Suitable for family trips, corporate travel, or leisure tours, this service combines convenience, comfort, and punctuality."
  },
  {
    "name": "One Way Cab Gujarat",
    "description": "One Way Cab Gujarat provides a convenient and cost-effective solution for travelers going from Pune to Gujarat without a return trip. Fully air-conditioned vehicles with professional chauffeurs ensure a safe, timely, and comfortable journey, ideal for families, groups, corporate travelers, or solo passengers."
  },
  {
    "name": "Round Trip Cab Gujarat",
    "description": "Round Trip Cab Gujarat offers flexible travel options for passengers planning to return to Pune after visiting Gujarat. Fully air-conditioned, well-maintained vehicles with professional chauffeurs ensure safety, comfort, and punctuality. Perfect for family vacations, corporate travel, or group tours seeking reliable long-distance round-trip services."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune allows passengers to conveniently book cabs for Pune to Gujarat trips anytime, anywhere. Users can select cab type, pickup and drop locations, date, and trip duration with instant confirmation. Fully air-conditioned vehicles with professional chauffeurs ensure a smooth, safe, and comfortable journey, making online booking hassle-free and reliable."
  }
],
"tableData": [
  ["Pune to Gujarat Cab Service", "Gujarat Cab from Pune"],
  ["AC Cab Pune to Gujarat", "Luxury Cab Gujarat Trip"],
  ["Family Cab Gujarat", "Outstation Cab Gujarat"],
  ["Affordable Cab Gujarat", "Chauffeur Driven Cab Gujarat"],
  ["Best Cab Pune to Gujarat", "Pune Gujarat Taxi"],
  ["Tourist Cab Gujarat", "Long Distance Cab Pune"],
  ["One Way Cab Gujarat", "Round Trip Cab Gujarat"],
  ["Online Cab Booking Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Gujarat Cab Service with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab services from Pune to Gujarat, perfect for business trips, family travel, and long-distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well‑Maintained Cabs",
    "WhyChoosedescription": "Travel in air‑conditioned, clean, and regularly serviced cabs for a smooth and stress-free journey from Pune to Gujarat."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with Pune to Gujarat routes, ensuring safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Pune to Gujarat cab services, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our team is available round the clock to assist with bookings, travel inquiries, and itinerary updates."
  },
  {
    "WhyChooseheading": "Flexible Travel Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized cab packages tailored to your Pune to Gujarat travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before each trip to ensure passenger safety and hygiene."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Gujarat cab travel."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services from Pune to Gujarat?',
    answer: 'Yes, Sanavi Travels offers comfortable and reliable cab services from Pune to Gujarat.'
  },
  {
    question: 'How can I book a cab from Pune to Gujarat?',
    answer: 'You can book through our website or by contacting our 24x7 customer support team for assistance.'
  },
  {
    question: 'What types of cabs are available for Pune to Gujarat travel?',
    answer: 'Sanavi Travels provides sedans, SUVs, and premium cars suitable for long-distance travel.'
  },
  {
    question: 'Are drivers experienced for Pune to Gujarat trips?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Pune to Gujarat routes.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup and drop-off points for your Pune to Gujarat journey.'
  },
  {
    question: 'Is the Pune to Gujarat cab service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round-the-clock cab services to match your travel schedule.'
  },
  {
    question: 'Are the vehicles sanitized before trips?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized before each journey.'
  },
  {
    question: 'What payment options are available for cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Gujarat trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vivek Shah',
    feedback: 'Booked a cab from Pune to Gujarat with Sanavi Travels. Comfortable ride, punctual service, and professional driver. Highly recommended!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Shreya Deshmukh',
    feedback: 'Excellent experience! The cab was clean and comfortable, and the driver was very professional throughout the journey.',
    rating: 5
  }
];






















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Gujarat Cab Service - Sanavi Travels",
  "description": "Book Pune to Gujarat cabs with Sanavi Travels. AC and luxury cabs for family trips, outstation journeys, long-distance travel, one-way or round trips, tourist trips, and comfortable chauffeur-driven service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Pune to Gujarat Cab Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury cabs from Pune to Gujarat with Sanavi Travels. Ideal for family trips, outstation journeys, long-distance travel, one-way or round trips, tourist trips, and safe chauffeur-driven service."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/62.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogujratcabservice;